import type { PrimaryEntityId } from "building-types/doc/primaryEntityId";
import type { DocEntityBase } from "building-types/entities/docEntityBase";
import type { OSBProfile, PlywoodProfile, SpanRating } from "building-types/framing/lumberTypes";

export enum SheathingType {
  PLYWOOD = "PLYWOOD",
  OSB = "OSB",
  FIBERBOARD = "FIBERBOARD",
  OTHER = "OTHER",
  DRYWALL = "DRYWALL",
}

export interface SheathingBase<T extends SheathingType> extends DocEntityBase<"SHEATHING_COMPONENT"> {
  readonly id: PrimaryEntityId<"SHEATHING_COMPONENT">;
  readonly name: string;
  readonly sheathingType: T;
  readonly thickness: number;
}

export interface Plywood extends SheathingBase<SheathingType.PLYWOOD> {
  readonly spanRating: SpanRating;
  readonly profile: PlywoodProfile;
}

export interface Osb extends SheathingBase<SheathingType.OSB> {
  readonly spanRating: SpanRating;
  readonly profile: OSBProfile;
}

export interface Drywall extends SheathingBase<SheathingType.DRYWALL> {}

export interface Other extends SheathingBase<SheathingType.OTHER> {
  readonly spanRating: string;
}

export type SheathingComponentEntity = Plywood | Osb | Other | Drywall;

export type SheathingComponentId = SheathingComponentEntity["id"];

export type SheathingComponentEntityTable = {
  [id: SheathingComponentId]: SheathingComponentEntity;
};
